export const initialConditionTasksFormValues = {
  taskTypeIds: [],
  conditionTaskTypes: {},
};
